





























































import LazyComponent from "v-lazy-component/vue2";
import { SfLoader, SfPagination } from "@storefront-ui/vue";
import CategoryProductCard from "~/modules/catalog/category/components/views/CategoryProductCard.vue";
import { useProductsWithCommonProductCardProps } from "~/modules/catalog/category/components/views/useProductsWithCommonCardProps";

import {
  defineComponent,
  onMounted,
  useRoute,
  computed,
} from "@nuxtjs/composition-api";
import type { Product } from "~/modules/catalog/product/types";
import { useWishlist } from "~/modules/wishlist/composables/useWishlist";
import wishlistGetters from "~/modules/wishlist/getters/wishlistGetters";
import { useWishlistStore } from "~/modules/wishlist/store/wishlistStore";
import SkeletonLoader from "~/components/SkeletonLoader/index.vue";
import ProductLoadItem from "~/components/SkeletonLoader/ProductLoadItem.vue";

export default defineComponent({
  name: "MyWishlist",
  components: {
    SfLoader,
    CategoryProductCard,
    SfPagination,
    LazyComponent,
    SkeletonLoader,
    ProductLoadItem  
  },
  setup() {
    const { load, loading } = useWishlist();
    const route = useRoute();
    const {
      query: { page, itemsPerPage },
    } = route.value;
    const wishlistStore = useWishlistStore();

    const products = computed(() =>
      wishlistGetters.getProducts(wishlistStore.wishlist)
    );
    const pagination = computed(() =>
      wishlistGetters.getPagination(wishlistStore.wishlist)
    );

    const productObjects = computed(() =>
      products.value.map((item) => item.product as Product)
    );

    const { productsWithCommonProductCardProps: productsWithCommonProps } =
      useProductsWithCommonProductCardProps(productObjects);

    onMounted(async () => {
      await load({
        searchParams: {
          currentPage: page ? Number.parseInt(page.toString(), 8) : 1,
          pageSize: itemsPerPage
            ? Number.parseInt(itemsPerPage.toString(), 8)
            : 8,
        },
      });
    });

    return {
      loading,
      pagination,
      products,
      productsWithCommonProps,
    };
  },
});
